var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstAid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.417,
    height: 17,
    viewBox: "0 0 18.417 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "first-aid",
    d: "M2.763,5.667a.933.933,0,0,0-.921.944v7.556a.933.933,0,0,0,.921.944H15.654a.933.933,0,0,0,.921-.944V6.611a.933.933,0,0,0-.921-.944ZM4.6,3.778V2.833A2.8,2.8,0,0,1,7.367,0H11.05a2.8,2.8,0,0,1,2.763,2.833v.944h1.842a2.8,2.8,0,0,1,2.762,2.833v7.556A2.8,2.8,0,0,1,15.654,17H2.763A2.8,2.8,0,0,1,0,14.167V6.611A2.8,2.8,0,0,1,2.763,3.778Zm1.842,0h5.525V2.833a.933.933,0,0,0-.921-.944H7.367a.933.933,0,0,0-.921.944ZM8.288,7.556h1.842v5.667H8.288ZM6.446,9.444h5.525v1.889H6.446Z",
    fill: "#8a8a8a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstAid);
export default __webpack_public_path__ + "static/media/first-aid.a7e226e8.svg";
export { ForwardRef as ReactComponent };